import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

type FormHintProps = {
  isDisabled?: boolean;
  isSelected?: boolean;
} & ComponentPropsWithoutRef<'small'>;

export const FormHint: FC<FormHintProps> = ({
  isDisabled,
  isSelected,
  ...props
}) => {
  return (
    <div>
      <small
        {...props}
        className={cn(
          `legacy:text-legacy-xs`,
          isDisabled
            ? `
              text-foreground-surface-disabled
              legacy:text-legacy-inactive
            `
            : isSelected
              ? 'text-white'
              : `
                text-foreground-surface-subdued
                legacy:text-legacy-brand-light-2
              `,
          props.className
        )}
      />
    </div>
  );
};
